import {
  Box,
  Button,
  Chip,
  CircularProgress,
  FormLabel,
  Tab,
  Tabs,
  useMediaQuery,
} from "@mui/material";
import { useEffect, useState } from "react";
import { ChevronLeft } from "react-feather";
import { useTheme } from "@mui/system";
import Attivita from "../tabs/dettagli/Attivita";
import Condizioni from "../tabs/dettagli/Condizioni";
import Documenti from "../tabs/dettagli/Documenti";
import Dettagli from "./Dettagli";
import Precontrattuale from "../tabs/dettagli/Precontrattuale";
import Generali from "../tabs/dettagli/Generali";
import { TabsWrapper } from "../style";
import { API_BASE_URL } from "../../../../config";
import { useNavigate } from "react-router-dom";
import { useFormRCAutoDetails } from "../rcautoContext";

const CustomTabPanel = (props) => {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box>{children}</Box>}
    </div>
  );
};

const VaiAiDettagli = ({ setVaiSection, dataset }) => {
  const [activeTab, setActiveTab] = useState(0);
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState([]);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const item = dataset[0];
  const navigate = useNavigate();
  const { dispatch: dispatchForm } = useFormRCAutoDetails();

  const fetchMessages = async () => {
    const token = sessionStorage.getItem("token");
    if (!item?.idUID || !token) return;

    try {
      const requestOptions = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          authorization: "Bearer " + token,
        },
        body: JSON.stringify({
          idUIDRequest: item.idUID,
        }),
      };

      const response = await fetch(
        `${API_BASE_URL}/api/requestGetMessage`,
        requestOptions,
      );
      const res = await response.json();

      if (res.status === -1) {
        sessionStorage.clear();
        window.location.href = "/auth/sign-in";
        return;
      }

      if (res.data) {
        dispatchForm({ type: "UPDATE_MESSAGGI", payload: res.data });
      }
    } catch (e) {
      console.log("Error fetching messages:", e);
    }
  };

  useEffect(() => {
    fetchMessages();
  }, [item?.idUID]);

  async function richiesteGetDetails() {
    const token = sessionStorage.getItem("token");
    try {
      const requestOptions = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          authorization: "Bearer " + token,
        },
        body: JSON.stringify({
          idUIDRequest: item?.idUID,
        }),
      };

      const response = await fetch(
        `${API_BASE_URL}/api/requestGetDetails`,
        requestOptions,
      );
      const responseData = await response.json();

      if (responseData.status === -1) {
        sessionStorage.clear();
        navigate("/auth/sign-in");
      }

      return responseData.data;
    } catch (error) {
      return error;
    }
  }

  useEffect(() => {
    richiesteGetDetails()
      .then((data) => {
        setData(data);
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  return (
    <>
      {loading ? (
        <Box
          sx={{
            width: "100%",
            display: "flex",
            justifyContent: "center",
            height: "1000px",
          }}
        >
          <CircularProgress />
        </Box>
      ) : (
        <Box sx={{ width: "100%" }}>
          <Button onClick={() => setVaiSection(false)}>
            <ChevronLeft />
            <FormLabel>Torna indietro</FormLabel>
          </Button>
          {/* {dataset[0]?.idUID} */}
          <Box
            display="flex"
            flexDirection={isMobile ? "column" : "row"}
            gap={4}
          >
            <Box width={isMobile ? "100%" : "50%"}>
              <TabsWrapper>
                <Tabs
                  value={activeTab}
                  onChange={(_, newValue) => setActiveTab(newValue)}
                  sx={{
                    width: "100%",
                    mt: 2,
                    mb: 4,
                    backgroundColor:
                      theme.palette.mode === "light" ? "#fff" : "#233044",
                  }}
                  variant="scrollable"
                  scrollButtons="auto"
                  allowScrollButtonsMobile
                >
                  <Tab label="Generali" />
                  <Tab label="Attività" />
                  <Tab label="Condizioni" />
                  <Tab label="Documenti" />
                  <Tab label="Precontrattuale" />
                </Tabs>
                <CustomTabPanel value={activeTab} index={0}>
                  <Generali item={item} />
                </CustomTabPanel>
                <CustomTabPanel value={activeTab} index={1}>
                  {/* <RCA dataset={rca} /> */}
                  <Attivita idUID={item?.idUID} fetchMessages={fetchMessages} />
                </CustomTabPanel>
                <CustomTabPanel value={activeTab} index={2}>
                  {/* <CVT dataset={cvt} /> */}
                  <Condizioni />
                </CustomTabPanel>
                <CustomTabPanel value={activeTab} index={3}>
                  {/* <CVT dataset={cvt} /> */}
                  <Documenti documenti={item?.documenti} />{" "}
                  {/* Passare i documenti dalla'arrai documenti nel preventivo */}
                </CustomTabPanel>
                <CustomTabPanel value={activeTab} index={4}>
                  {/* <CVT dataset={cvt} /> */}
                  <Precontrattuale data={item} />
                </CustomTabPanel>
              </TabsWrapper>
            </Box>
            <Box width={isMobile ? "100%" : "50%"} mt={2}>
              <Box width="100%" mb={4}>
                <Chip
                  sx={{
                    backgroundColor: `#${item?.sCol}`,
                    color: item?.sCol === "336699" ? "white" : "black",
                    fontSize: 18,
                    fontWeight: "bold",
                    width: "100%",
                    height: "3rem",
                  }}
                  label={item?.sDesc}
                />
              </Box>
              <Dettagli type="RCA" dataPreventivo={data.richiesta[0]} />
            </Box>
          </Box>
        </Box>
      )}
    </>
  );
};

export default VaiAiDettagli;
